export default "__VITE_ASSET__DCP_RHpo__"